<template>
  <div class="wrapper">
    <!-- <van-search
      v-model="value"
      shape="round"
      background="#FFF"
      placeholder="请搜索导航科室"
      @input="handleQuery"
    >
      <template v-slot:left-icon>
        <img src="@/assets/payment/sousuo_icon.png" class="ss_icon" />
      </template>
    </van-search> -->
    <ul class="yardList" v-if="showIf">
      <li class="title">院区列表</li>
      <li @click="push(item.hspCode,item.hspName)" v-for="item in yardList" :key="item.hspCode">
        <ul class="content">
          <li class="name">{{item.hspName}}</li>
          <li class="grade">
            <span v-for="it in item.slogan" :key="it">{{it}}</span>
          </li>
          <li class="phone_area">
            <span>
              <img src="@/assets/brief/phone2.png" />
              <span>{{item.phone}}</span>
            </span>
            <span>
              <img src="@/assets/brief/area.png" />
              <span>{{item.address}}</span>
            </span>
          </li>
        </ul>
      </li>
    </ul>
    <div class="query_content" v-if="!showIf">
      暂无信息
    </div>
  </div>
</template>

<script>
import { selectBHosptialinfo } from "@/request/api.js"
export default {
  data() {
    return {
      value: "",
      showIf: true,
      yardList: []
    };
  },
  async created() {
    let res = await selectBHosptialinfo();
    this.yardList = res.data.obj;
    this.yardList.forEach(el => {
      el.slogan = el.slogan.split('，')
    });
  },
  methods: {
    handleQuery() {
      if (this.value) {
        this.showIf = false;
      } else {
        this.showIf = true;
      }
    },
    push(hspCode,name) {
      this.$router.push(`/HospitalNavigation/buildingSelect?hspCode=${hspCode}&hspName=${name}`);
    },
    clear(){}
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #f8f8f8;
  /deep/ .van-search__content {
    background-color: #e4e4e4;
  }
  .ss_icon {
    position: relative;
    top: 2px;
    width: 11px;
    height: 13px;
  }
  .content {
    // padding: 25px;
    flex: 1;
    display: flex;
    flex-flow: column nowrap;
    letter-spacing: 1px;
    .name {
      font-size: 17px;
      font-weight: bold;
    }
    .grade {
      margin: 14px 0px 22px;
      font-size: 14px;
      > span {
        color: #2a9dce;
        margin-right: 4px;
        padding: 3px 7px;
        border: 1px solid #2a9dce;
        border-radius: 3px;
      }
    }
    .phone_area {
      position: relative;
      display: flex;
      flex-flow: column nowrap;
      font-size: 14px;
      color: #bebebe;
      padding-bottom: 10px;
      > span {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        margin-bottom: 4px;
        > img {
          width: 17px;
          height: 20px;
        }
        > span {
          margin-left: 6px;
        }
      }
      .callphone {
        position: absolute;
        top: -7px;
        right: 0px;
        width: 32px;
        height: 32px;
        > img {
          width: 32px;
          height: 32px;
        }
      }
    }
    .details {
      > p {
        font-size: 16px;
        margin-bottom: 10px;
        font-weight: 600;
      }
      > span {
        line-height: 25px;
        font-size: 14px;
        color: #707070;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
    }
  }
  .yardList{
    margin-top: 10px;
    background-color: #FFF;
    display: flex;
    flex-flow: column nowrap;
    >li{
      flex: 1;
      padding: 20px;
      border: 1px solid #eee;
      display: flex;
      flex-flow: row nowrap;
    }
    .title{
      font-weight: bold;
      font-size: 18px;
      padding: 10px 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Index/website/HospitalNavigation/HospitalNavigation.vue